import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { AccessManagementComponent } from './access-management/access-management.component';
import { AvailablePropertiesComponent } from './available-properties/available-properties.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ForgetUsernameComponent } from './forget-username/forget-username.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ManageNumbersComponent } from './manage-numbers/manage-numbers.component';
import { OperateDeviceComponent } from './operate-device/operate-device.component';
import { SmartDevicesComponent } from './operate-device/smart-devices.component';
import { QuickAccessComponent } from './quick-access/quick-access.component';
import { RegistrationComponent } from './registration/registration.component';
import { RequestAccessComponent } from './request-access/request-access.component';
import { SelectPropertyComponent } from './select-property/select-property.component';
import { UserProfilesComponent } from './user-profiles/user-profiles.component';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ToastrModule } from 'ngx-toastr';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ErrorStateMatcher, MatNativeDateModule } from '@angular/material/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TestRegistrationComponent } from './test-registration/test-registration.component';
import { AccessLogComponent } from './access-log/access-log.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { OrderByPipe } from './_helpers/order.pipe';
import { FilterPipe } from './_helpers/filter.pipe';
import { TouchedErrorStateMatcher } from './_helpers/touched-error-state.matcher';
import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { PercentPipe, CurrencyPipe } from '@angular/common';
import { VisitorComponent } from './visitor/visitor.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { ManageGuestComponent } from './manage-guest/manage-guest.component';
import { GuestAccessComponent } from './guest-access/guest-access.component';
import { KioskAccessComponent } from './kiosk-access/kiosk-access.component';
import { NoticesComponent } from './notices/notices.component';
import { ManageNoticesComponent } from './manage-notices/manage-notices.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

@NgModule({ declarations: [
        AppComponent,
        AuditLogComponent,
        AccessManagementComponent,
        AvailablePropertiesComponent,
        ChangePasswordComponent,
        ForgetPasswordComponent,
        ForgetUsernameComponent,
        HomeComponent,
        LoginComponent,
        ManageNumbersComponent,
        OperateDeviceComponent,
        QuickAccessComponent,
        RegistrationComponent,
        RequestAccessComponent,
        SelectPropertyComponent,
        UserProfilesComponent,
        UserRolesComponent,
        TestRegistrationComponent,
        AccessLogComponent,
        VisitorComponent,
        DeleteAccountComponent,
        ManageGuestComponent,
        GuestAccessComponent,
        KioskAccessComponent,
        NoticesComponent,
        ManageNoticesComponent,
        FilterPipe
    ],
    imports: [
      SmartDevicesComponent,
        BrowserModule,
        NgxPaginationModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FontAwesomeModule,
        FormsModule,
        MatTabsModule,
        MatIconModule,
        MatProgressBarModule,
        //ToastrModule.forRoot(),
        ToastrModule.forRoot({
          positionClass :'toast-top-right'
        }),
        NgbModule
      ],
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: ErrorStateMatcher, useClass: TouchedErrorStateMatcher },
        PercentPipe, CurrencyPipe, OrderByPipe,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync()
      ],
      bootstrap: [AppComponent]
  })
export class AppModule { }
